define('views/filefinder/Podio.Views.FileFinderPermissionWarning',['require','jquery','lib/backbone/Backbone.PodioView','lib/Podio.Utils','jst!filefinder/_permission_warning'],function(require) {

  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var podioUtils = require('lib/Podio.Utils');

  var jstPermissionWarning = require('jst!filefinder/_permission_warning');

  return PodioView.extend({

    podioEvents: {
      'click .cancel'                    : 'onCancelButtonClick',
      'click .done-update-permissions'   : 'onUpdatePermissionsButtonClick',
      'click .done-preserve-permissions' : 'onPreservePermissionsButtonClick'
    },

    initialize: function() {
      this._super();
      this.dfd = new $.Deferred();
    },

    render: function() {
      this.elm.html(this.getTemplate(jstPermissionWarning, {}));

      this.elm.appendTo(this.getOption('elmContainer'));

      if (!this.getOption('canPreservePermissions')) {
        this.elm.find('.done-preserve-permissions').hide();
      }
    },

    onCancelButtonClick : function(elmTarget, e) {
      e.stopPropagation();
      this.dispose();
      this.dfd.reject();
    },

    _onWarningDone : function(preservePermissions) {
      var rememberSettings = this.elm.find('input[name=never_again]').is(':checked');

      this.dispose();
      this.dfd.resolve(rememberSettings, preservePermissions);
    },

    onUpdatePermissionsButtonClick: function(elmTarget, e) {
      this._onWarningDone(false);
    },

    onPreservePermissionsButtonClick: function(elmTarget, e) {
      this._onWarningDone(true);
    },
  });

});

